import React, { useEffect, useState } from "react";
import {
  Navigate,
  NavLink,
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";
import logo from "../../assets/images/coewarri.png";
import {
  getCurrentUser,
  removeUser,
} from "../../components/services/auth/authService";
// import "./Style.css"
import { useContext } from "react";
import { AlignRight, Home, LogOut, Menu } from "react-feather";
import { GetApplicantDetails, GetPaymentStatus } from "../../api/application";
import avatar from "../../assets/images/user.png";
import AuthContext from "../../context/AuthContext";
import useDetails from "../../hooks/useDetails";
import useAdmission from "../../hooks/useAdmission";
import useProspective from "../../hooks/useProspective";
import useProspectiveInfo from "../../hooks/useProspectiveInfo";

function ApprovedWrapper() {
  const [transaction, setTransaction] = useState({});
  const [passport, setPassport] = useState();
  const [admissionFee, setAdmissionFee] = useState();
  const [resultFee, setResultFee] = useState();
  const [details, setDetails] = useState();
  let navigate = useNavigate();
  const user = getCurrentUser();
  const {data} = useProspective()
  const {staging:stage} = useProspectiveInfo()

  const token = localStorage.getItem("user-token");
  const location = useLocation();

  const fetchPaymentStatus = async () => {
    try {
      const { data } = await GetPaymentStatus(user.admission_id);
      console.log(data, "statuss");
      setAdmissionFee(data.application_fee);
      setResultFee(data.result_checking_fee);
    } catch (error) {}
  };

  // const getDetails = async () => {
  //   try {
  //     const { data } = await GetApplicantDetails(user.application_id);
  //     console.log("getting detais", data);
  //     setDetails(data);
  //     setPassport(data.photo);
  //       setStage(data.stage)
  //     let staging = data.stage;
  //     if (staging === null) {
  //       navigate("/apply/payment");
  //     } else if (staging === null){
  //       navigate("/apply/biodata");
  //     }else if (staging === "biodata") {
  //       navigate("/apply/biodata");
  //     } else if (staging === "nok") {
  //       navigate("/apply/education-details");
  //     } else if (staging === "educational") {
  //       navigate("/apply/preview");
  //     } else{
  //       navigate('/apply')
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  useEffect(() => {
    // getDetails();
    // fetchPaymentStatus()
  }, []);

  if (token === null) {
    return (
      <Navigate
        to={{
          pathname: `/apply/login`,
          state: { from: location },
        }}
        replace
      />
    );
  }

  const handleLogout = () => {
    localStorage.clear();
    navigate("/staff/admissions/clearance/login");
  };

  const logOut = () => {
    removeUser();
    navigate("/apply/login");
  };

  function toggle() {
    // Left menu collapse
    // $('.button-menu-mobile').on('click', function (event) {
    //     event.preventDefault();
    //     $("body").toggleClass("enlarge-menu");
    let toggleAble = document.querySelector("body");
    toggleAble.classList.toggle("enlarge-menu");
  }

  const onImageError = (e) => {
    e.target.src = avatar;
  };

  return (
    <>
      <div class="leftbar-tab-menu">
        <div class="main-icon-menu">
          <a
            href="../analytics/analytics-index.html"
            class="logo logo-metrica d-block text-center"
          >
            <span>
              {/* <img src="../assets/images/dspg_logo.png" alt="logo-small" className="logo-sm"/> */}
            </span>
          </a>
          <nav className="nav">
            <NavLink
              to="/apply"
              className="nav-link"
              data-toggle="tooltip-custom"
              data-placement="right"
              title=""
              data-original-title="Analytics"
              data-trigger="hover"
            >
              <Home className="align-self-center menu-icon icon-dual" />
            </NavLink>
          </nav>
          <div class="pro-metrica-end">
            <a
              href=""
              onClick={logOut}
              class="help"
              data-toggle="tooltip-custom"
              data-placement="right"
            >
              <LogOut class="align-self-center menu-icon icon-md icon-dual mb-4" />
            </a>
            <NavLink href="" class="profile">
              <img
                src={data?.photo}
                onError={onImageError}
                alt="profile-user"
                class="rounded-circle thumb-sm"
              />
            </NavLink>
          </div>
        </div>

        <div class="main-menu-inner">
          <div class="topbar-left">
            <a to="" class="logo">
              <span>
                <img
                  src={logo}
                  alt="logo-large"
                  class="logo-sm logo-dark"
                  style={{
                    width: "95%",
                    height: "95%",
                    marginLeft: "",
                    marginTop: "1rem",
                  }}
                />
              </span>
            </a>
          </div>
          <div class="menu-body slimscroll">
            <div class="title-box">
              <h6 class="menu-title">PG Dashboard</h6>
            </div>
            <ul className="nav">

                <>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/admission" end>
                      Dashboard
                    </NavLink>
                  </li>
                  {(stage === null || stage ==='approved') ?
                  <li class="nav-item">
                  <a class="nav-link" href="#"><span class="w-100">Payment</span><span class="menu-arrow"><i class="mdi mdi-chevron-right"></i></span></a>
                  <ul class="nav-second-level" aria-expanded="false">
                      <li><NavLink to="/admission/payment" end>Payment</NavLink></li>
                      <li><NavLink to="/admission/payment-invoice">Invoice</NavLink></li>
                  </ul>            
              </li>
              : (stage === 'submitted') ?
                 <> 
              <li class="nav-item">
              <a class="nav-link" href="#"><span class="w-100">Payment</span><span class="menu-arrow"><i class="mdi mdi-chevron-right"></i></span></a>
              <ul class="nav-second-level" aria-expanded="false">
                  <li><NavLink to="/admission/payment" end>Payment</NavLink></li>
                  <li><NavLink to="/admission/payment-invoice">Invoice</NavLink></li>
              </ul>            
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/admission/preview">
              Preview
            </NavLink>
          </li>
          </>
              :
              <>
                  <li class="nav-item">
                      <a class="nav-link" href="#"><span class="w-100">Payment</span><span class="menu-arrow"><i class="mdi mdi-chevron-right"></i></span></a>
                      <ul class="nav-second-level" aria-expanded="false">
                          <li><NavLink to="/admission/payment" end>Payment</NavLink></li>
                          <li><NavLink to="/admission/payment-invoice">Invoice</NavLink></li>
                      </ul>            
                  </li>
                     {/* <li className="nav-item">
                       <NavLink className="nav-link" to="/admission/upload-doc">
                         Upload Document
                       </NavLink>
                     </li>
                     <li className="nav-item">
                       <NavLink className="nav-link" to="/admission/change-of-course">
                         Change of Course
                       </NavLink>
                     </li>
                     <li className="nav-item">
                       <NavLink className="nav-link" to="/admission/biodata">
                         Biodata
                       </NavLink>
                     </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/admission/education-details">
                      Education Details
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/admission/preview">
                      Preview
                    </NavLink>
                  </li> */}
                  </>
                  }
                  </>
            </ul>
          </div>
        </div>
      </div>

      <div class="topbar">
        <nav class="navbar-custom">
          <ul class="list-unstyled topbar-nav float-right mb-0">
            <li class="dropdown notification-list">
              <a
                class="nav-link dropdown-toggle arrow-none waves-light waves-effect"
                data-toggle="dropdown"
                href="#"
                role="button"
                aria-haspopup="false"
                aria-expanded="false"
              >
                <i class="ti-bell noti-icon"></i>
                <span class="badge badge-danger badge-pill noti-icon-badge">
                  2
                </span>
              </a>
              <div class="dropdown-menu dropdown-menu-right dropdown-lg pt-0">
                <h6 class="dropdown-item-text font-15 m-0 py-3 bg-primary text-white d-flex justify-content-between align-items-center">
                  Notifications{" "}
                  <span class="badge badge-light badge-pill">2</span>
                </h6>
                <div class="slimscroll notification-list">
                  <a href="#" class="dropdown-item py-3">
                    <small class="float-right text-muted pl-2">2 min ago</small>
                    <div class="media">
                      <div class="avatar-md bg-primary">
                        <i class="la la-cart-arrow-down text-white"></i>
                      </div>
                      <div class="media-body align-self-center ml-2 text-truncate">
                        <h6 class="my-0 font-weight-normal text-dark">
                          Your order is placed
                        </h6>
                        <small class="text-muted mb-0">
                          Dummy text of the printing and industry.
                        </small>
                      </div>
                    </div>
                  </a>
                  <a href="#" class="dropdown-item py-3">
                    <small class="float-right text-muted pl-2">
                      10 min ago
                    </small>
                    <div class="media">
                      <div class="avatar-md bg-success">
                        <i class="la la-group text-white"></i>
                      </div>
                      <div class="media-body align-self-center ml-2 text-truncate">
                        <h6 class="my-0 font-weight-normal text-dark">
                          Meeting with designers
                        </h6>
                        <small class="text-muted mb-0">
                          It is a long established fact that a reader.
                        </small>
                      </div>
                    </div>
                  </a>
                  <a href="#" class="dropdown-item py-3">
                    <small class="float-right text-muted pl-2">
                      40 min ago
                    </small>
                    <div class="media">
                      <div class="avatar-md bg-pink">
                        <i class="la la-list-alt text-white"></i>
                      </div>
                      <div class="media-body align-self-center ml-2 text-truncate">
                        <h6 class="my-0 font-weight-normal text-dark">
                          UX 3 Task complete.
                        </h6>
                        <small class="text-muted mb-0">
                          Dummy text of the printing.
                        </small>
                      </div>
                    </div>
                  </a>
                  <a href="#" class="dropdown-item py-3">
                    <small class="float-right text-muted pl-2">1 hr ago</small>
                    <div class="media">
                      <div class="avatar-md bg-warning">
                        <i class="la la-truck text-white"></i>
                      </div>
                      <div class="media-body align-self-center ml-2 text-truncate">
                        <h6 class="my-0 font-weight-normal text-dark">
                          Your order is placed
                        </h6>
                        <small class="text-muted mb-0">
                          It is a long established fact that a reader.
                        </small>
                      </div>
                    </div>
                  </a>
                  <a href="#" class="dropdown-item py-3">
                    <small class="float-right text-muted pl-2">2 hrs ago</small>
                    <div class="media">
                      <div class="avatar-md bg-info">
                        <i class="la la-check-circle text-white"></i>
                      </div>
                      <div class="media-body align-self-center ml-2 text-truncate">
                        <h6 class="my-0 font-weight-normal text-dark">
                          Payment Successfull
                        </h6>
                        <small class="text-muted mb-0">
                          Dummy text of the printing.
                        </small>
                      </div>
                    </div>
                  </a>
                </div>
                <a
                  href="javascript:void(0);"
                  class="dropdown-item text-center text-primary"
                >
                  View all <i class="fi-arrow-right"></i>
                </a>
              </div>
            </li>

            <li class="dropdown">
              <a
                class="nav-link dropdown-toggle waves-effect waves-light nav-user"
                data-toggle="dropdown"
                href="#"
                role="button"
                aria-haspopup="false"
                aria-expanded="false"
              >
                <img
                  src={data?.photo}
                  alt="user"
                  onError={onImageError}
                  class="rounded-circle"
                />
                <span class="ml-1 nav-user-name hidden-sm">
                  {data?.othername} <i class="mdi mdi-chevron-down"></i>{" "}
                </span>
              </a>
              <div class="dropdown-menu dropdown-menu-right">
                <a class="dropdown-item" href="#">
                  <i class="dripicons-user text-muted mr-2"></i> Profile
                </a>
                <a class="dropdown-item" href="#">
                  <i class="dripicons-wallet text-muted mr-2"></i> My Wallet
                </a>
                <a class="dropdown-item" href="#">
                  <i class="dripicons-gear text-muted mr-2"></i> Settings
                </a>
                <a class="dropdown-item" href="#">
                  <i class="dripicons-lock text-muted mr-2"></i> Lock screen
                </a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#">
                  <i class="dripicons-exit text-muted mr-2"></i> Logout
                </a>
              </div>
            </li>
            <li class="mr-2">
              <a
                href="#"
                class="nav-link"
                data-toggle="modal"
                data-animation="fade"
                data-target=".modal-rightbar"
              >
                <AlignRight class="align-self-center" />
              </a>
            </li>
          </ul>

          <ul class="list-unstyled topbar-nav mb-0">
            <li>
              <a href="../analytics/analytics-index.html">
                <span class="responsive-logo">
                  <img
                    src={logo}
                    alt="logo-small"
                    class="logo-sm align-self-center"
                    height="34"
                  />
                </span>
              </a>
            </li>
            <li>
              <button class="button-menu-mobile nav-link waves-effect waves-light">
                <Menu onClick={toggle} class="align-self-center"></Menu>
              </button>
            </li>
            <li class="hide-phone app-search">
              <h4>College of Education, Warri (Postgraduate)</h4>
            </li>
          </ul>
        </nav>
      </div>
      <Outlet />
    </>
  );
}

export default ApprovedWrapper;
